"use client"

import { useEffect } from "react"
import posthog from "posthog-js"

export function ViewTracker() {
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_POSTHOG_TOKEN) {
      posthog.capture("comparison_page_viewed", {
        comparison: "zenthor_vs_serasa_hibp_spycloud",
      })
    }
  }, [])
  return null
}
